// extracted by mini-css-extract-plugin
export default {"mainDiv":"TopNavigation_mainDiv__XgqTi","nav":"TopNavigation_nav__hduF5","logoDiv":"TopNavigation_logoDiv__oWjMP","logo":"TopNavigation_logo__toFaJ"};